<template>
  <div id="#app">
    <router-view></router-view>
  </div>

</template>

<script>
export default {
  data () {
    return {

    }
  },

  methods: {

  }
}
</script>

<style>
  body, #app{
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
  }




</style>



// WEBPACK FOOTER //
// src/App.vue